import { Button } from "@mui/material";
import { toasterMessages } from "modules/constants/QuestionBankConstants";
import { Toaster } from "modules/platform-components/Toaster";
import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { MultiSelect } from "react-multi-select-component";
import { toast } from "react-toastify";
import { AppContext } from "../../context/AppContext";
import {
  apiPaths,
  postData,
} from "../platform-components/api-integration-util";
import { PreLoader } from "../platform-components/PreLoader";
import { getEditQuestion } from "../platform-components/utils/configuration";
import { getUserDetails } from "../platform-components/utils/shared-data.service";
import "./addquestion.scss";

const UploadQuestion = (props) => {
  let [question, updateQuestion] = useState({});
  let [edit, updateEdit] = useState(getEditQuestion());
  let [loading, updateLoading] = useState(false);

  let [uploadMediaInformation, setUploadMediaInformation] = useState({});
  let { topics, courses, tags, subjects } = useContext(AppContext);
  const [availableTopics, setAvailableTopics] = useState([]);
  const [selectedSubjectId, setsubjectId] = useState(null);

  const [tagOptions, setTagOptions] = useState([]);
  const [multiSelectTagValue, setMultiSelectTagValue] = useState([]);
  const [courseOptions, setCourseOptions] = useState([]);
  const [multiSelectCourseValue, setMultiSelectCourseValue] = useState([]);
  const [topicOptions, setTopicOptions] = useState([]);
  const [multiSelectTopicValue, setMultiSelectTopicValue] = useState([]);

  const [selectedFile, setSelectedFile] = useState(null);
  const [questionType, setQuestionType] = useState("Easy");

  const {
    register,
    handleSubmit,
    watch,
    errors,
    setValue,
    getValues,
    triggerValidation,
  } = useForm();

  const onFileChange = (event) => {
    // Update the state
    setSelectedFile(event.target.files[0]);
  };

  useEffect(() => {
    if (tags) {
      setTagOptions(
        tags.map((tag) => {
          return {
            label: tag.tagName,
            value: tag.tagId,
          };
        })
      );
    }
  }, [tags]);

  useEffect(() => {
    if (availableTopics) {
      setTopicOptions(
        availableTopics.map((topic) => {
          return {
            label: topic.topic,
            value: topic.topicId,
          };
        })
      );
    }
  }, [availableTopics]);

  useEffect(() => {
    if (courses) {
      setCourseOptions(
        courses.map((course) => {
          return {
            label: course.course,
            value: course.courseId,
          };
        })
      );
    }
  }, [courses]);

  useEffect(() => {
    if (!selectedSubjectId && subjects.length > 0) {
      setsubjectId(subjects.map((ele) => ele.subjectId)?.[0]);
    }
    if (selectedSubjectId) {
      setAvailableTopics(
        topics.filter((topic) => topic.subjectId === +selectedSubjectId)
      );
    }
  }, [getValues, selectedSubjectId, subjects, topics]);

  const onSave = async (questionStatus) => {
    if (errors && Object.keys(errors)?.length > 0) {
      return;
    }
    let data = {
      ...watch(),
      tenantId: getUserDetails()?.tenantId,
      questionStatus,
      createdBy: getUserDetails().email || "",
      updatedBy: getUserDetails().email || "",
      createdDate: question?.createdDate,
    };
    data.subjectId = +data.subjectId;

    let values = { ...watch() };
    data.answerType = values.answerType;
    data.courseIds = multiSelectCourseValue.map((el) => el.value);

    data.tagIds = multiSelectTagValue.map((el) => el.value);
    data.topicIds = multiSelectTopicValue.map((el) => el.value);
    data.mediaId = uploadMediaInformation?.mediaId || 0;
    data.questionType = questionType;
    data.tenantId = getUserDetails().tenantId;

    let formData = new FormData();
    if (selectedFile) {
      formData.append("file", selectedFile, selectedFile.name);
    }

    let queryString = ``

    if(selectedSubjectId) {
      queryString += `subjectId=${selectedSubjectId}&`
    } else {
      Toaster(toast.TYPE.ERROR, 'Subject Not Selected')
    }

    if(data.topicIds.length> 0) {
      queryString += `topicIds=${data.topicIds.join(',')}&`
    } else {
      queryString += `topicIds=&`
    }

    if(data.courseIds.length> 0) {
      queryString += `courseIds=${data.courseIds.join(',')}&`
    } else {
      queryString += `courseIds=&`
    }

    if(data.tagIds.length > 0) {
      queryString += `tagIds=${data.tagIds.join(',')}&`
    } else {
      queryString += `tagIds=&`
    }
      queryString += `questionComplexity=${questionType}&`


    postData(`${apiPaths.uploadQuestions}?${queryString}`, {
      data: formData,
      headers: {
        tenantId: data?.tenantId,
        userEmail: getUserDetails().email,
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        props.history.push("/app/dashboard");
      })
      .catch((e) => {
        Toaster(toast.TYPE.ERROR, toasterMessages.FAIL.DEFAULT)
      });
  };

  const onsub = () => {
    if (process && process.exit) process.exit(1);
  };

  return (
    <div style={{ display: "flex", width: "100%", flexFlow: "column" }}>
      {loading ? (
        <div>
          <PreLoader />
        </div>
      ) : (
        <div className="addquestion-main">
          <div
            className="main-heading"
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            Upload Question
          </div>
          <div>
            <div className="background-common-div">
              <div className="addquestion-sub">
                <form onSubmit={handleSubmit(onsub)} className="form-div">
                  <div className="btn-div" style={{ float: "right" }}>
                    <React.Fragment>
                      <button
                        className="btn-common"
                        onClick={() => onSave("SAVED")}
                      >
                        Save
                      </button>
                    </React.Fragment>
                  </div>

                  <div className="common-div">
                    <div className="row">
                      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <div className="form-sub-div">
                          <h6 className="text-bold">Subject</h6>
                          <div className="form-elements">
                            <select
                              className="form-details questions"
                              name="subjectId"
                              value={selectedSubjectId}
                              readOnly={!edit}
                              onChange={(e) => {
                                setsubjectId(e.target.value);
                              }}
                            >
                              {subjects.map((ele) => (
                                <option
                                  key={ele?.subject}
                                  value={ele?.subjectId}
                                >
                                  {ele?.subject}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="form-sub-div">
                          <h6 className="text-bold">Courses</h6>
                          <div className="form-elements">
                            <MultiSelect
                              ref={register({ required: true })}
                              options={courseOptions} // Options to display in the dropdown
                              value={multiSelectCourseValue} // Preselected value to persist in dropdown
                              onChange={setMultiSelectCourseValue} // Function will trigger on select event
                              labelledBy={"Please Select"}
                              hasSelectAll={true}
                            />
                          </div>
                        </div>
                        <div className="form-sub-div">
                          <h6 className="text-bold">Tags</h6>
                          <div className="form-elements">
                            <MultiSelect
                              ref={register({ required: true })}
                              options={tagOptions} // Options to display in the dropdown
                              value={multiSelectTagValue} // Preselected value to persist in dropdown
                              onChange={setMultiSelectTagValue} // Function will trigger on select event
                              labelledBy={"Please Select"}
                              hasSelectAll={true}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <div className="form-sub-div">
                          <h6 className="text-bold">Topic</h6>
                          <div className="form-elements">
                            <MultiSelect
                              ref={register({ required: true })}
                              options={topicOptions} // Options to display in the dropdown
                              value={multiSelectTopicValue} // Preselected value to persist in dropdown
                              onChange={setMultiSelectTopicValue} // Function will trigger on select event
                              labelledBy={"Please Select"}
                              hasSelectAll={true}
                            />
                          </div>
                        </div>
                        <div className="form-sub-div">
                          <h6 className="text-bold">Complexity</h6>
                          <div className="form-elements">
                            <select
                              className="form-details questions"
                              name="questionType"
                              value={questionType}
                              readOnly={!edit}
                              onChange={(e) => {
                                setQuestionType(e.target.value);
                              }}
                            >
                              <option>EASY</option>
                              <option>MEDIUM</option>
                              <option>HARD</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {errors?.Topics}
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      <Button variant="contained" component="label">
        Upload File
        <input type="file" hidden onChange={onFileChange} />
      </Button>
      <p style={{ margin: "20px" }}>
        {selectedFile?.name || "No file selected"}
      </p>
    </div>
  );
};

export default UploadQuestion;
